import * as actions from './actions';
import reducer from './reducers';
import * as operations from './operations';

export default reducer;
export {
  actions,
  operations,
};
